// location-selector-customizer.js

(function() {
  'use strict';

  // Get store data from Shopify Customizer (passed from Liquid)
  let storeData = [];
  let sectionSettings = {};

  // Initialize with data from Liquid template
  function initializeData() {
    if (window.storeLocatorData) {
      storeData = window.storeLocatorData.stores || [];
      sectionSettings = window.storeLocatorData.settings || {};
    } else {
      console.warn('Store locator data not found. Make sure the Liquid template is properly configured.');
      storeData = [];
    }
  }

  // Generate location data from store data
  function generateLocationData() {
    const locationData = {};
    
    storeData.forEach(store => {
      const state = store.state;
      const city = store.city;
      const locality = store.locality;
      
      if (!locationData[state]) {
        locationData[state] = {};
      }
      
      if (!locationData[state][city]) {
        locationData[state][city] = [];
      }
      
      if (!locationData[state][city].includes(locality)) {
        locationData[state][city].push(locality);
      }
    });
    
    return locationData;
  }

  // DOM elements
  let stateSelect, citySelect, localitySelect, searchButton;
  let storesGrid, noResults, resultsSummary, resultsCount, selectedLocation;
  
  // Current selections
  let currentState = '';
  let currentCity = '';
  let currentLocality = '';
  let locationData = {};
  let filteredStores = [];

  // Initialize the location selector
  function init() {
    // Initialize data from Liquid template
    initializeData();
    
    // Generate location data from stores
    locationData = generateLocationData();
    
    // Get DOM elements
    stateSelect = document.getElementById('state-select');
    citySelect = document.getElementById('city-select');
    localitySelect = document.getElementById('locality-select');
    searchButton = document.getElementById('location-search-btn');
    storesGrid = document.getElementById('stores-grid');
    noResults = document.getElementById('no-results');
    resultsSummary = document.getElementById('results-summary');
    resultsCount = document.getElementById('results-count');
    selectedLocation = document.getElementById('selected-location');

    // Check if elements exist
    if (!stateSelect || !citySelect || !localitySelect || !searchButton || !storesGrid) {
      console.error('Location selector elements not found');
      return;
    }

    // Check if we have store data
    if (storeData.length === 0) {
      console.warn('No store data available. Please add stores in the Shopify customizer.');
      displayNoStoresMessage();
      return;
    }

    // Initialize dropdowns and stores
    populateStates();
    displayAllStores();
    
    // Add event listeners
    stateSelect.addEventListener('change', handleStateChange);
    citySelect.addEventListener('change', handleCityChange);
    localitySelect.addEventListener('change', handleLocalityChange);
    searchButton.addEventListener('click', handleSearch);
    
    // Clear filter button
    const clearFilterBtn = document.getElementById('clear-filter');
    if (clearFilterBtn) {
      clearFilterBtn.addEventListener('click', clearFilters);
    }
    
    // Show all stores button
    const showAllBtn = document.getElementById('show-all-stores');
    if (showAllBtn) {
      showAllBtn.addEventListener('click', clearFilters);
    }

    // Debug: Log store names and map links for verification
    console.log('=== DEBUGGING MAP LINKS ===');
    storeData.forEach(store => {
      const hasCustomLink = store.mapLink && store.mapLink.trim() !== '';
      console.log(`${store.name}: ${hasCustomLink ? '✓ HAS CUSTOM LINK' : '✗ USING FALLBACK'}`);
      if (!hasCustomLink) {
        console.log(`  Will use fallback for: "${store.name}"`);
      }
    });
  }

  // Display message when no stores are configured
  function displayNoStoresMessage() {
    if (storesGrid) {
      storesGrid.innerHTML = `
        <div style="grid-column: 1 / -1; text-align: center; padding: 2rem; background: white; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
          <h3 style="color: #514537; margin-bottom: 0.5rem;">No stores configured</h3>
          <p style="color: #80776b; margin: 0;">Please add store locations in the Shopify customizer to display them here.</p>
        </div>
      `;
    }
  }

  // Populate states dropdown
  function populateStates() {
    const states = Object.keys(locationData).sort();
    
    stateSelect.innerHTML = '<option value="">Select State</option>';
    
    states.forEach(state => {
      const option = document.createElement('option');
      option.value = state;
      option.textContent = state;
      stateSelect.appendChild(option);
    });
  }

  // Populate cities dropdown based on selected state
  function populateCities(state) {
    const cities = state && locationData[state] ? Object.keys(locationData[state]).sort() : [];
    
    citySelect.innerHTML = '<option value="">All Cities</option>';
    
    cities.forEach(city => {
      const option = document.createElement('option');
      option.value = city;
      option.textContent = city;
      citySelect.appendChild(option);
    });
  }

  // Populate localities dropdown based on selected state and city
  function populateLocalities(state, city) {
    const localities = state && city && locationData[state] && locationData[state][city] 
      ? locationData[state][city].sort() 
      : [];
    
    localitySelect.innerHTML = '<option value="">All Localities</option>';
    
    localities.forEach(locality => {
      const option = document.createElement('option');
      option.value = locality;
      option.textContent = locality;
      localitySelect.appendChild(option);
    });
  }

  // Handle state selection change
  function handleStateChange(event) {
    currentState = event.target.value;
    currentCity = '';
    currentLocality = '';
    
    citySelect.value = '';
    localitySelect.value = '';
    
    if (currentState) {
      citySelect.disabled = false;
      populateCities(currentState);
      localitySelect.disabled = true;
      populateLocalities('', '');
    } else {
      citySelect.disabled = true;
      localitySelect.disabled = true;
      populateCities('');
      populateLocalities('', '');
    }
  }

  // Handle city selection change
  function handleCityChange(event) {
    currentCity = event.target.value;
    currentLocality = '';
    
    localitySelect.value = '';
    
    if (currentCity && currentState) {
      localitySelect.disabled = false;
      populateLocalities(currentState, currentCity);
    } else {
      localitySelect.disabled = true;
      populateLocalities('', '');
    }
  }

  // Handle locality selection change
  function handleLocalityChange(event) {
    currentLocality = event.target.value;
  }

  // Filter stores based on selections
  function filterStores() {
    let filtered = storeData;
    
    if (currentState) {
      filtered = filtered.filter(store => 
        store.state.toLowerCase() === currentState.toLowerCase()
      );
    }
    
    if (currentCity) {
      filtered = filtered.filter(store => 
        store.city.toLowerCase() === currentCity.toLowerCase()
      );
    }
    
    if (currentLocality) {
      filtered = filtered.filter(store => 
        store.locality.toLowerCase().includes(currentLocality.toLowerCase())
      );
    }
    
    return filtered;
  }

  // Generate map direction URL - IMPROVED with better fallback handling
  function generateDirectionUrl(store) {
    // Check if we have a specific map link for this store from customizer
    if (store.mapLink && store.mapLink.trim() !== '') {
      console.log(`Using custom map link for: ${store.name}`);
      return store.mapLink;
    }
    
    console.log(`No custom link found for: "${store.name}", using improved fallback`);
    
    // IMPROVED: More precise fallback URL construction
    // Use place search instead of directions to avoid automatic routing
    const searchQuery = encodeURIComponent(`${store.name} ${store.address} ${store.city} ${store.state} ${store.pinCode}`);
    return `https://www.google.com/maps/search/?api=1&query=${searchQuery}`;
  }

  // Create store card HTML
  function createStoreCard(store) {
    const directionUrl = generateDirectionUrl(store);
    
    return `
      <div class="store-card">
        <h3 class="store-name">${store.name}</h3>
        <div class="store-info">
          <div class="store-info-item">
            <span class="store-info-label">City:</span>
            <span class="store-info-value">${store.city}</span>
          </div>
          <div class="store-info-item">
            <span class="store-info-label">State:</span>
            <span class="store-info-value">${store.state}</span>
          </div>
          <div class="store-info-item">
            <span class="store-info-label">Pin Code:</span>
            <span class="store-info-value">${store.pinCode}</span>
          </div>
          <div class="store-info-item">
            <span class="store-info-label">Phone:</span>
            <span class="store-info-value"><a href="tel:${store.phone}">${store.phone}</a></span>
          </div>
          <div class="store-info-item">
            <span class="store-info-label">Email:</span>
            <span class="store-info-value"><a href="mailto:${store.email}">${store.email}</a></span>
          </div>
          <div class="store-info-item">
            <span class="store-info-label">Address:</span>
            <span class="store-info-value">${store.address}</span>
          </div>
          <div class="store-info-item">
            <span class="store-info-label">Timing:</span>
            <span class="store-info-value">${store.timing}</span>
          </div>
        </div>
        <div class="store-actions">
          <a href="${directionUrl}" target="_blank" class="direction-button" rel="noopener noreferrer">
            <svg class="direction-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>
            </svg>
            Get Directions
          </a>
        </div>
      </div>
    `;
  }

  // Display stores
  function displayStores(stores) {
    if (!storesGrid) return;
    
    if (stores.length === 0) {
      storesGrid.style.display = 'none';
      noResults.style.display = 'block';
    } else {
      storesGrid.style.display = 'grid';
      noResults.style.display = 'none';
      storesGrid.innerHTML = stores.map(store => createStoreCard(store)).join('');
    }
  }

  // Display all stores
  function displayAllStores() {
    displayStores(storeData);
    hideResultsSummary();
  }

  // Show results summary
  function showResultsSummary(count, location) {
    if (resultsSummary && resultsCount && selectedLocation) {
      resultsCount.textContent = count;
      selectedLocation.textContent = location;
      resultsSummary.style.display = 'block';
    }
  }

  // Hide results summary
  function hideResultsSummary() {
    if (resultsSummary) {
      resultsSummary.style.display = 'none';
    }
  }

  // Clear all filters
  function clearFilters() {
    currentState = '';
    currentCity = '';
    currentLocality = '';
    
    stateSelect.value = '';
    citySelect.value = '';
    localitySelect.value = '';
    
    citySelect.disabled = true;
    localitySelect.disabled = true;
    
    populateCities('');
    populateLocalities('', '');
    
    displayAllStores();
  }

  // Handle search button click
  function handleSearch() {
    if (!currentState) {
      alert('Please select a state');
      return;
    }

    // Filter stores
    filteredStores = filterStores();
    
    // Create location string for display
    let locationString = currentState;
    if (currentCity) {
      locationString += ` > ${currentCity}`;
    }
    if (currentLocality) {
      locationString += ` > ${currentLocality}`;
    }
    
    // Display filtered stores
    displayStores(filteredStores);
    
    // Show results summary
    showResultsSummary(filteredStores.length, locationString);
    
    // Scroll to results
    if (storesGrid) {
      storesGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Make functions globally accessible if needed
  window.LocationSelector = {
    init: init,
    clearFilters: clearFilters,
    filterStores: filterStores,
    addStore: function(storeData) {
      // Function to programmatically add stores
      if (window.storeLocatorData && window.storeLocatorData.stores) {
        window.storeLocatorData.stores.push(storeData);
        init(); // Reinitialize
      }
    },
    // Add debug function to check map links
    debugMapLinks: function() {
      console.log('=== MAP LINKS DEBUG ===');
      storeData.forEach(store => {
        const hasCustomLink = store.mapLink && store.mapLink.trim() !== '';
        console.log(`"${store.name}": ${hasCustomLink ? 'HAS CUSTOM LINK' : 'USING FALLBACK'}`);
        if (hasCustomLink) {
          console.log(`  Custom Link: ${store.mapLink}`);
        }
      });
    }
  };

})();